/*
 jsで読み込むstaticファイルにバージョンを付与する
 主にriot_tagで使用
*/
const $ = require('jquery')

module.exports = (function () {
  function setSvgPath (svgHash) {
    const assetsVersion = $('meta[name=assets-version]').attr('content')
    return '/static/svg/sprite.svg?v=' + assetsVersion + svgHash
  }

  return {
    setSvgPath: setSvgPath
  }
})()
